/**
 * MIRE dashboard widgets — wired into `mireConfig.dashboard`.
 *
 * A single intro widget; the shared Dashboard shell owns the heading and subtitle.
 */

import type { WidgetConfig } from '#lib/apps/types.js';
import IntroWidget from '#lib/components/dashboard/IntroWidget.svelte';

export const widgets: WidgetConfig[] = [
	{
		id: 'summary',
		component: IntroWidget,
		props: { text: 'View Model Inventory of Roadway Elements (MIRE) data for your network.' }
	}
];
